import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83ccf350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-modal-header flex middle-xs between-xs" }
const _hoisted_2 = { class: "medium black" }
const _hoisted_3 = { class: "flex middle-xs center-xs" }

import CloseIcon from '@/views/icons/CloseIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModalHeaderComponent',
  emits: ['onClose'],
  setup(__props, { emit }) {



const handleClose = () => {
  emit('onClose');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CloseIcon, {
        onClick: handleClose,
        role: "button"
      })
    ])
  ]))
}
}

})